// extracted by mini-css-extract-plugin
export var numberInputContainer = "_63-0";
export var startPickingButton = "_63-1";